<template>
  <div class="inc-dec-button-holder" :class="getLayout" @click.stop="" v-show="getIsPrint">
    <div class="inc-button" :style="getBgColor" @mousedown="startInc" @mouseup="stopInterval" @mouseleave="stopInterval" @contextmenu="stopInterval">
      <img ref="plus" :src="require('@/assets/svg/SVG/plus_btn.svg')" class="plus"/>
    </div>
    <div class="inc-divider"></div>
    <div class="dec-button" :style="getBgColor" @mousedown="startDec" @mouseup="stopInterval"  @mouseleave="stopInterval" @contextmenu="stopInterval">
      <img ref="minus" :src="require('@/assets/svg/SVG/minus_btn.svg')" class="plus"/>
    </div>
  </div>
</template>

<script>
import { usePrintStore } from '../../store/PrintStore';

export default {
  name: 'IncDecButtons',
  data () {
    return {
      interval: null
    };
  },
  props: [
    'layout',
    'buttonColor'
  ],
  emits: [
    'inc',
    'dec',
  ],
  computed : {
    getBgColor () {
      return 'background-color: ' + (this.buttonColor ? this.buttonColor + ' !important' : 'darkgray') + ';';
    },
    getIsPrint () {
      return !usePrintStore().getPrintIsOpen;
    },
    getLayout () {
      return this.layout === 'row' ? 'idb-row' : '';
    }
  },
  methods: {

    // todo: add interval to mouse down to inc/dec

    handleInc () {
      this.$emit('inc');
    },
    handleDec () {
      this.$emit('dec');
    },
    startInc () {
      this.stopInterval();
      this.handleInc();
      // todo: change to setTimeout to make dynamic speed ramp
      this.interval = setInterval(this.handleInc, 200);
    },
    startDec () {
      this.stopInterval();
      this.handleDec();
      this.interval = setInterval(this.handleDec, 200);
    },
    stopInterval () {
      clearInterval(this.interval);
    }
  }
};
</script>

<style scoped>

.idb-row {
  flex-direction: row !important;
}
.inc-dec-button-holder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 10px;
  transform: translateY(1px);
/*  margin-left: 8px;
  margin-right: 8px;*/
}
.inc-divider {
  height: 1px;
  margin: 2px;
}
.inc-button,
.dec-button {
  width: 18px;
  height: 18px;
/*  background-color: darkgray;*/
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-content: center;
  cursor: pointer;
}
.plus {
  width: 100%;
}
</style>